import { INSTAGRAM } from '@/lib/socialProfile';

import { SCHEDULER, SCHEDULER_FEED_VIEW } from '@/routes/privateRoutes';

export const TAB_CALENDAR_VIEW = 'calendar_view';
export const TAB_FEED_VIEW = 'feed_view';

export const tabsList = [
    {
        name: 'scheduler:tabs.calendar_view',
        icon: 'content',
        id: TAB_CALENDAR_VIEW,
        url: SCHEDULER,
        label: 'scheduler:tabs.calendar_view'
    },
    {
        name: 'scheduler:tabs.feed_view',
        icon: 'feed',
        id: TAB_FEED_VIEW,
        socialProfileRestriction: [INSTAGRAM],
        url: SCHEDULER_FEED_VIEW,
        label: 'scheduler:tabs.feed_view'
    }
] as const;
